module.exports = __webpack_public_path__ + "img/courier-abffreight.eaae7580.svg";